import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { PlanService } from './../../../data/repository/plan-repository/plan.service';
import { DateHelper } from './../../../utils/date-helper';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-edit-fasting-start-time-bottomsheet',
  templateUrl: './edit-fasting-start-time-bottomsheet.component.html',
  styleUrls: ['./edit-fasting-start-time-bottomsheet.component.scss'],
})
export class EditFastingStartTimeBottomsheetComponent implements OnInit {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };

  hours = [];
  minutes = [];
  days = [];

  selectedMinute = 0;
  selectedHour = 0;
  selectedDay = 0;

  minuteElementTop = 150;
  hourElementTop = 150;
  dayElementTop = 150;

  showLoading = false;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<EditFastingStartTimeBottomsheetComponent>,
    private dateHelper: DateHelper,
    private planService: PlanService,
    private snackBarService: SnackBarService
  ) {}

  ngOnInit() {
    this.hours = [...Array(24).keys()];
    this.minutes = [...Array(60).keys()];
    this.days = ['دیروز', 'امروز'];

    if (this.dateHelper.isSameDay(new Date(), new Date(this.data.startTime))) {
      this.selectedDay = 1;
      this.dayElementTop = 105;
      document.getElementById('fastingDays').style.top =
        this.dayElementTop.toString() + 'px';
    }

    const hour = new Date(this.data.startTime).getHours();
    this.selectedHour = hour;
    this.hourElementTop -= 45 * hour;
    document.getElementById('fastingHours').style.top =
      this.hourElementTop.toString() + 'px';

    const minute = new Date(this.data.startTime).getMinutes();
    this.selectedMinute = minute;
    this.minuteElementTop -= 45 * minute;
    document.getElementById('fastingMinutes').style.top =
      this.minuteElementTop.toString() + 'px';
  }

  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }

  swipeMinutes(action: string = this.SWIPE_ACTION.DOWN, event) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.previousMinute(event.velocity);
    }
    if (action === this.SWIPE_ACTION.UP) {
      this.nextMinute(event.velocity);
    }
  }

  nextMinute(velocity: number) {
    if (this.selectedMinute < 59) {
      velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);
      this.selectedMinute += velocity;
      let overhead = 0;
      if (this.selectedMinute > 59) {
        overhead = this.selectedMinute - 59;
        this.selectedMinute = 59;
      }
      this.minuteElementTop -= 45 * (velocity - overhead);
      document.getElementById('fastingMinutes').style.top =
        this.minuteElementTop.toString() + 'px';
    }
  }

  previousMinute(velocity: number) {
    if (this.selectedMinute > 0) {
      velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);
      this.selectedMinute -= velocity;
      let overhead = 0;
      if (this.selectedMinute < 0) {
        overhead = 0 - this.selectedMinute;
        this.selectedMinute = 0;
      }
      this.minuteElementTop += 45 * (velocity - overhead);
      document.getElementById('fastingMinutes').style.top =
        this.minuteElementTop.toString() + 'px';
    }
  }

  swipeHours(action: string = this.SWIPE_ACTION.DOWN, event) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.previousHour(event.velocity);
    }
    if (action === this.SWIPE_ACTION.UP) {
      this.nextHour(event.velocity);
    }
  }

  nextHour(velocity: number) {
    if (this.selectedHour < 23) {
      velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);
      this.selectedHour += velocity;
      let overhead = 0;
      if (this.selectedHour > 23) {
        overhead = this.selectedHour - 23;
        this.selectedHour = 23;
      }
      this.hourElementTop -= 45 * (velocity - overhead);
      document.getElementById('fastingHours').style.top =
        this.hourElementTop.toString() + 'px';
    }
  }

  previousHour(velocity: number) {
    if (this.selectedHour > 0) {
      velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);
      this.selectedHour -= velocity;
      let overhead = 0;
      if (this.selectedHour < 0) {
        overhead = 0 - this.selectedHour;
        this.selectedHour = 0;
      }
      this.hourElementTop += 45 * (velocity - overhead);
      document.getElementById('fastingHours').style.top =
        this.hourElementTop.toString() + 'px';
    }
  }

  swipeDays(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.previousDay();
    }
    if (action === this.SWIPE_ACTION.UP) {
      this.nextDay();
    }
  }

  nextDay() {
    if (this.selectedDay < 1) {
      this.selectedDay++;
      this.dayElementTop -= 45;
      document.getElementById('fastingDays').style.top =
        this.dayElementTop.toString() + 'px';
    }
  }

  previousDay() {
    if (this.selectedDay > 0) {
      this.selectedDay--;
      this.dayElementTop += 45;
      document.getElementById('fastingDays').style.top =
        this.dayElementTop.toString() + 'px';
    }
  }

  submit() {
    this.showLoading = true;
    let startTime = new Date(
      new Date().setHours(this.selectedHour, this.selectedMinute, 0, 0)
    );
    if (this.selectedDay === 0) {
      startTime = new Date(startTime.setDate(startTime.getDate() - 1));
    }
    this.planService
      .changeFastingStartTime(startTime.getTime(), this.data.dietId)
      .then((res) => {
        if (res.isSuccess()) {
          this.bottomSheetRef.dismiss({ needRefresh: true });
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.showLoading = false;
      });
  }

  cancel() {
    this.bottomSheetRef.dismiss();
  }
}
